"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chianni": {
    "55934bae": [{
      "hkey": "613e7e62",
      "slug": "i-gulfi",
      "name": "I Gulfi",
      "primary": true,
      "skipSearch": false
    }],
    "i-guelfi": [{
      "hkey": "613e7e62",
      "slug": "i-gulfi",
      "name": "I Gulfi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "098b291d": [{
      "hkey": "66d3b10a",
      "slug": "chianni",
      "name": "Chianni",
      "primary": true,
      "skipSearch": false
    }],
    "la-pescaia": [{
      "hkey": "66d3b10a",
      "slug": "chianni",
      "name": "Chianni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;